var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$style.container,
        ((_obj = {}), (_obj[_vm.$style.active] = _vm.isSelected), _obj)
      ],
      on: { click: _vm.handleClick, mouseenter: _vm.handleMouseenter }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }